interface ValidationResponse {
  isValid: boolean;
  message?: string;
}

export const validatePostalCode = (code: string): ValidationResponse => {
  // Nigerian postal codes are 6 digits
  const postalCodeRegex = /^\d{6}$/;
  return {
    isValid: postalCodeRegex.test(code),
    message: postalCodeRegex.test(code) ? undefined : "Please enter a valid 6-digit postal code"
  };
};

export const validatePhoneNumber = (phone: string): ValidationResponse => {
  // Nigerian phone numbers: +234 or 0, followed by 9-10 digits
  const phoneRegex = /^(\+234|0)[0-9]{9,10}$/;
  return {
    isValid: phoneRegex.test(phone),
    message: phoneRegex.test(phone) ? undefined : "Please enter a valid Nigerian phone number"
  };
};

export const validateAddress = (address: string): ValidationResponse => {
  return {
    isValid: address.length >= 10,
    message: address.length >= 10 ? undefined : "Please enter a complete street address"
  };
};

export const validateName = (name: string): ValidationResponse => {
  const isValid = name.trim().length >= 2;
  return {
    isValid,
    message: isValid ? undefined : "Please enter a valid name"
  };
}

export const validateEmail = (email: string): ValidationResponse => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValid = emailRegex.test(email);
  return {
    isValid,
    message: isValid ? undefined : "Please enter a valid email address"
  };
}
